import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface VolumeIconProps {
  color?: string;
  height?: string;
  width?: string;
  style?: React.CSSProperties;
}

export const VolumeIcon = ({
  color = RoutalPalette.secondary40,
  height = `24px`,
  width = `24px`,
  style = {},
}: VolumeIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22.34 23.25" style={{ width, height, fill: `none`, ...style }}>
      <path
        fill={color}
        d="m11.17,2.26c1.89,1.64,6.29,6.09,6.29,11.82,0,4.04-2.82,7.33-6.29,7.33s-6.29-3.28-6.29-7.33c0-5.7,4.41-10.17,6.29-11.82m0-1.84S3.46,6.03,3.46,14.08c0,4.83,3.45,8.75,7.71,8.75s7.71-3.92,7.71-8.75c0-8.07-7.71-13.66-7.71-13.66h0Z"
      />
      <path
        fill={color}
        d="m11.44,19.58c-.31,0-.61-.04-.91-.1-.39-.08-.64-.45-.56-.84.08-.39.45-.64.84-.56.02,0,.03,0,.05.01,1.32.32,2.66-.5,2.98-1.82.06-.25.08-.5.06-.76-.03-.39.26-.73.65-.76s.73.26.76.65c.16,2.14-1.45,4.01-3.6,4.16-.09,0-.18.01-.28.01h0Z"
      />
    </SvgIcon>
  );
};
